class AuthTokenProvider {

    constructor(config) {
        this.token = null;
        if (config.user !== undefined) {
            this.token = config.authToken;
        }
    }

    getToken(callback) {
        callback(this.token);
    }
}
